import { combineReducers } from 'redux';
import Auth from './Auth';
import Theme from './Theme';
import System from './System.reducer';


const reducers = combineReducers({
    theme: Theme,
    auth: Auth,
    system: System
});

export default reducers;
